export enum DashboardVersion {
  CURRENT = 'CURRENT',
  VNEXT = 'VNEXT',
}
